export default __webpack_public_path__ + "static/media/@belaechic.blog.296d344a.jpg";